@if (isIdpSelectionActive() && !isCheckingSsoSession() && !isAutoRedirecting()) {
  <ng-container *transloco="let t; prefix: 'login'">
    <h2>{{ t('newLoginText') }}</h2>

    <div class="pb-3" [innerHTML]="t('newLoginInfo')"></div>

    <div class="text-center py-3">
      <app-switch-edu-button
        [disabled]="isProcessingLegacyLogin()"
        [isLoading]="isProcessingSwitchEduLogin()"
        (click)="processSwitchEduIdLogin()"
      ></app-switch-edu-button>
    </div>

    @if (hasLoginError()) {
      <div class="alert alert-danger mt-3" role="alert">
        {{ t('loginError') }}
      </div>
    }

    <div class="pt-3" [innerHTML]="t('newLoginAdditionalInfo')"></div>

    <hr />

    <app-legacy-login-card
      [disabled]="isProcessingSwitchEduLogin()"
      [isLoading]="isProcessingLegacyLogin()"
      (loginButtonClicked)="processLegacyLogin()"
    ></app-legacy-login-card>
  </ng-container>
} @else if (!isIdpSelectionActive() && hasLoginError()) {
  <!-- Selection is off, so there is no ui to fall back to. Only reachable when the automatic redirect failed. -->
  <ng-container *transloco="let t; prefix: 'login'">
    <div class="alert alert-danger mt-3" role="alert">
      {{ t('loginError') }}
    </div>
  </ng-container>
} @else {
  <pmt-loading-indicator></pmt-loading-indicator>
}
